import {Nullable} from './app/TypeHelpers'

export class CookieHelper {
    static getStringValue(key: string): Nullable<string> {
        const cookies: string = document.cookie

        if (cookies) {
            const cookieItems: string[] = cookies.split(';')
            let value: Nullable<string> = null

            cookieItems.forEach((cookieItem) => {
                const elem: string[] = cookieItem.split('=')
                if (elem[0].trim() === key) {
                    value = decodeURIComponent(elem[1])
                }
            })

            return value
        } else {
            return null
        }
    }

    static setStringValue(key: string, value: string, ...options: {key:string, value:string}[]): void {
        const now: Date = new Date()
        now.setFullYear(now.getFullYear() + 3)
        const defaultPath: string = '/'
        document.cookie = `${key}=${encodeURIComponent(value)};expires=${now.toUTCString()};path=${defaultPath};${options.map(option => `${option.key}=${option.value}`).join(';')}`
    }

    static clearValue(key: string, ...options: {key:string, value:string}[]): void {
        document.cookie = `${key}=; max-age=0;${options.map(option => `${option.key}=${option.value}`).join(';')}`
    }
}
